export default __webpack_public_path__ + "static/media/w_underweight.ff55c1d4.svg";